<div class="title" l10nTranslate>shared.additionalTicketInfo</div>
<div class="additional-summary">
  <div class="additional-summary__form">
    <div class="additional-summary__form-label" l10nTranslate>shared.dateCreated</div>
    <div class="additional-summary__form-info">
      {{ ticketDetail.createTs | dateWithFormat: { suffixFormat: ' h:mm a' } }}
    </div>
  </div>
  <div class="additional-summary__form">
    <div class="additional-summary__form-label" l10nTranslate>shared.dateUpdated</div>
    <div class="additional-summary__form-info">
      {{ ticketDetail.updateTs | dateWithFormat: { suffixFormat: ' h:mm a' } }}
    </div>
  </div>
  <div class="additional-summary__form">
    <div class="additional-summary__form-label" l10nTranslate>shared.pageIssueEnteredFrom</div>
    <div class="additional-summary__form-info">
      {{ page }}
    </div>
  </div>
  <div *ngIf="!isProfile" class="addto_dropdown">
    <div class="additional-summary__input-label" l10nTranslate>shared.addToJira</div>
    <div class="additional-summary__input">
      <mat-form-field appearance="outline">
        <input type="text" autocomplete="no-autofill" matInput placeholder="JIRA #" [formControl]="jiraNumberCtrl" />
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="!isProfile" class="estimate_dropdown">
    <div class="additional-summary__input-label" l10nTranslate>shared.estimatedReleaseDate</div>
    <div class="additional-summary__input">
      <mat-form-field appearance="outline">
        <input
          matInput
          autocomplete="no-autofill"
          [matDatepicker]="picker"
          [placeholder]="'shared.chooseDate' | xTranslate"
          [formControl]="estimatedReleaseDateCtrl"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
